// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"_3Ln-iNPO1PKsglFBE9rZgr"};